import { deviceLabels, deviceSeriesKeys } from '@utils/aiAlerts/mapping';
import { get } from 'lodash';
import { useCallback, useEffect } from 'react';

//TODO: move out legend callback

function useLegend({ instance, enabled = false, seriesList = [] }) {
  const toggleLegend = useCallback(() => {
    if (instance) {
      const option = instance.getOption();
      const { legend } = option;

      const toggleState = !get(legend, '0.show', false);
      const topGridSize = toggleState ? 30 : 10;

      instance.setOption({
        legend: { show: toggleState, data: seriesList },
        grid: { top: topGridSize },
      });
    }
  }, [instance, enabled, seriesList]);

  // disable impacted device series by default
  const disableTotalImpactedUniqueDevices = useCallback(() => {
    instance.dispatchAction({
      type: 'legendUnSelect',
      name: deviceLabels.totalCumulativeImpactedUniques,
    });
  }, [instance]);

  useEffect(() => {
    if (instance && enabled) {
      disableTotalImpactedUniqueDevices();
    }
  }, [instance, enabled, disableTotalImpactedUniqueDevices]);

  return { toggleLegend };
}

export default useLegend;

/* TODO: remove post product conirmation about device series

  // turn off all device series
  const handleLegendChange = (params) => {
    const { name, selected } = params;
    const deviceSeriesNames = Object.values(deviceLabels);
    if (deviceSeriesNames.includes(name)) {

      const action = selected[name] ? 'legendSelect' : 'legendUnSelect';

      deviceSeriesNames.filter(seriesName => seriesName !== name)
        .forEach(filteredName => {
          instance.dispatchAction({
            type: action,
            name: filteredName,
          });
        });
    }
  }

  // register chart events
  useEffect(() => {
    if (instance && enabled) {
      instance.on('legendselectchanged', handleLegendChange);
      return () => {
        instance.off('legendselectchanged', handleLegendChange);
      }
    }
  }, [instance, enabled, handleLegendChange]);


*/
